// Imports: local files.
import {
  GET_TOOL_LEVELS_START,
  GET_TOOL_LEVELS_SUCCESS,
  GET_TOOL_LEVELS_FAILED,
  GET_TOOL_LEVELS_RESET,
  GET_TOOL_LEVEL_START,
  GET_TOOL_LEVEL_SUCCESS,
  GET_TOOL_LEVEL_FAILED,
  GET_TOOL_LEVEL_RESET,
  CREATE_TOOL_LEVEL_START,
  CREATE_TOOL_LEVEL_SUCCESS,
  CREATE_TOOL_LEVEL_FAILED,
  CREATE_TOOL_LEVEL_RESET,
  UPDATE_TOOL_LEVEL_START,
  UPDATE_TOOL_LEVEL_SUCCESS,
  UPDATE_TOOL_LEVEL_FAILED,
  UPDATE_TOOL_LEVEL_RESET,
  DELETE_TOOL_LEVEL_START,
  DELETE_TOOL_LEVEL_SUCCESS,
  DELETE_TOOL_LEVEL_FAILED,
  DELETE_TOOL_LEVEL_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const toolLevelsReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Tool Levels
     * =======================================================================
     */
    case GET_TOOL_LEVELS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_TOOL_LEVELS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_TOOL_LEVELS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_TOOL_LEVELS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Tool Level
     * =======================================================================
     */
    case GET_TOOL_LEVEL_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_TOOL_LEVEL_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_TOOL_LEVEL_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_TOOL_LEVEL_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create Tool Level
     * =======================================================================
     */
    case CREATE_TOOL_LEVEL_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_TOOL_LEVEL_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_TOOL_LEVEL_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_TOOL_LEVEL_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Tool Level
     * =======================================================================
     */
    case UPDATE_TOOL_LEVEL_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TOOL_LEVEL_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TOOL_LEVEL_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TOOL_LEVEL_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Tool Level
     * =======================================================================
     */
    case DELETE_TOOL_LEVEL_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TOOL_LEVEL_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TOOL_LEVEL_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TOOL_LEVEL_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default toolLevelsReducer;
